import React, { useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { HiOutlineArrowLeft, HiOutlineCalendar, HiOutlineClock, HiOutlineShieldCheck } from "react-icons/hi";
import HomeNav from "../../Components/Navbar/NewNavbar";
import Footer from "../../Components/Footer/Footer";

const Checkout = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        mobile: "",
        address: "",
        zip: ""
    });
    const [selectedDate, setSelectedDate] = useState("");
    const [selectedTime, setSelectedTime] = useState("");
    
    const location = useLocation();
    const navigate = useNavigate();
    const cart = location.state?.cart || [];

    const getDateOptions = () => {
        const options = [];
        const today = new Date();
        for (let i = 0; i < 7; i++) {
            const date = new Date();
            date.setDate(today.getDate() + i);
            options.push({
                day: date.toLocaleString('en-US', { weekday: 'short' }),
                date: date.toLocaleDateString(),
                displayDate: date.getDate(),
                month: date.toLocaleString('en-US', { month: 'short' })
            });
        }
        return options;
    };

    const handleInputChange = (e) => {
        const { id, value } = e.target;
        setFormData({ ...formData, [id]: value });
    };

    const handlePayment = (e) => {
        e.preventDefault();
        // Simulate secure transition
        window.open('https://play.google.com/store/apps/details?id=com.cleanto.astraclean', '_blank');
    };

    const calculateSubtotal = () => {
        return cart.reduce((total, item) => total + (item.discountedPrice * (item.qty || 1)), 0);
    };

    return (
        <div className="bg-white min-h-screen">
            <HomeNav />
            
            <section className="pt-32 pb-20">
                <div className="container-custom">
                    <div className="flex flex-col md:flex-row md:items-center justify-between gap-6 mb-12">
                        <div className="space-y-2">
                            <h1 className="text-4xl md:text-5xl font-heading font-black text-foreground">Secure <span className="text-primary italic">Checkout</span></h1>
                            <p className="text-muted-foreground font-medium">Almost there! Complete your booking details.</p>
                        </div>
                        <button onClick={() => navigate('/cart')} className="inline-flex items-center gap-2 text-sm font-black uppercase tracking-widest text-primary hover:gap-3 transition-all">
                            <HiOutlineArrowLeft size={18} />
                            Back to Cart
                        </button>
                    </div>

                    <form onSubmit={handlePayment} className="grid lg:grid-cols-12 gap-12 items-start">
                        {/* Billing Details */}
                        <div className="lg:col-span-8 space-y-10">
                            <div className="card-premium p-8 space-y-8">
                                <h3 className="text-2xl font-bold flex items-center gap-3">
                                    <span className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary text-sm font-black">01</span>
                                    Billing Information
                                </h3>
                                
                                <div className="grid md:grid-cols-2 gap-6">
                                    <div className="space-y-2">
                                        <label className="text-sm font-black uppercase tracking-widest text-muted-foreground ml-1">Full Name</label>
                                        <input 
                                            type="text" 
                                            id="name" 
                                            required 
                                            placeholder="John Doe" 
                                            className="w-full px-6 py-4 rounded-2xl bg-secondary border border-transparent focus:border-primary focus:bg-white transition-all outline-none font-medium"
                                            value={formData.name} 
                                            onChange={handleInputChange} 
                                        />
                                    </div>
                                    <div className="space-y-2">
                                        <label className="text-sm font-black uppercase tracking-widest text-muted-foreground ml-1">Email Address</label>
                                        <input 
                                            type="email" 
                                            id="email" 
                                            required 
                                            placeholder="john@example.com" 
                                            className="w-full px-6 py-4 rounded-2xl bg-secondary border border-transparent focus:border-primary focus:bg-white transition-all outline-none font-medium"
                                            value={formData.email} 
                                            onChange={handleInputChange} 
                                        />
                                    </div>
                                    <div className="space-y-2">
                                        <label className="text-sm font-black uppercase tracking-widest text-muted-foreground ml-1">Contact Number</label>
                                        <input 
                                            type="tel" 
                                            id="mobile" 
                                            required 
                                            placeholder="+91 9876543210" 
                                            className="w-full px-6 py-4 rounded-2xl bg-secondary border border-transparent focus:border-primary focus:bg-white transition-all outline-none font-medium"
                                            value={formData.mobile} 
                                            onChange={handleInputChange} 
                                        />
                                    </div>
                                    <div className="space-y-2">
                                        <label className="text-sm font-black uppercase tracking-widest text-muted-foreground ml-1">Zip Code</label>
                                        <input 
                                            type="text" 
                                            id="zip" 
                                            required 
                                            placeholder="110001" 
                                            className="w-full px-6 py-4 rounded-2xl bg-secondary border border-transparent focus:border-primary focus:bg-white transition-all outline-none font-medium"
                                            value={formData.zip} 
                                            onChange={handleInputChange} 
                                        />
                                    </div>
                                    <div className="md:col-span-2 space-y-2">
                                        <label className="text-sm font-black uppercase tracking-widest text-muted-foreground ml-1">Complete Address</label>
                                        <textarea 
                                            id="address" 
                                            required 
                                            placeholder="Flat/House No., Building, Street, Landmark" 
                                            className="w-full px-6 py-4 rounded-2xl bg-secondary border border-transparent focus:border-primary focus:bg-white transition-all outline-none font-medium min-h-[120px]"
                                            value={formData.address} 
                                            onChange={handleInputChange} 
                                        />
                                    </div>
                                </div>
                            </div>

                            <div className="card-premium p-8 space-y-8">
                                <h3 className="text-2xl font-bold flex items-center gap-3">
                                    <span className="w-10 h-10 rounded-full bg-primary/10 flex items-center justify-center text-primary text-sm font-black">02</span>
                                    Schedule Your Service
                                </h3>

                                <div className="space-y-8">
                                    <div className="space-y-4">
                                        <p className="inline-flex items-center gap-2 text-sm font-black uppercase tracking-widest text-primary">
                                            <HiOutlineCalendar size={18} />
                                            Which day works best?
                                        </p>
                                        <div className="flex gap-4 overflow-x-auto pb-4 custom-scrollbar">
                                            {getDateOptions().map((dateOption, index) => (
                                                <button
                                                    key={index}
                                                    type="button"
                                                    onClick={() => setSelectedDate(dateOption.date)}
                                                    className={`shrink-0 flex flex-col items-center justify-center w-24 h-28 rounded-2xl transition-all border-2 ${selectedDate === dateOption.date ? 'border-primary bg-primary text-white shadow-xl shadow-primary/20 scale-105' : 'border-border bg-secondary text-muted-foreground hover:border-primary/50'}`}
                                                >
                                                    <span className="text-[10px] font-black uppercase tracking-widest mb-1">{dateOption.day}</span>
                                                    <span className="text-2xl font-black">{dateOption.displayDate}</span>
                                                    <span className="text-xs font-bold uppercase tracking-widest mt-1">{dateOption.month}</span>
                                                </button>
                                            ))}
                                        </div>
                                    </div>

                                    <div className="space-y-4">
                                        <p className="inline-flex items-center gap-2 text-sm font-black uppercase tracking-widest text-primary">
                                            <HiOutlineClock size={18} />
                                            Select a time slot
                                        </p>
                                        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-3">
                                            {["8:00 AM", "9:00 AM", "10:00 AM", "11:00 AM", "12:00 PM", "1:00 PM", "2:00 PM", "3:00 PM", "4:00 PM", "5:00 PM", "6:00 PM", "7:00 PM"].map((time, index) => (
                                                <button
                                                    key={index}
                                                    type="button"
                                                    onClick={() => setSelectedTime(time)}
                                                    className={`px-3 py-2.5 rounded-xl text-xs font-black transition-all border-2 ${selectedTime === time ? 'border-primary bg-primary text-white shadow-lg' : 'border-border bg-secondary text-muted-foreground hover:border-primary/50'}`}
                                                >
                                                    {time}
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        {/* Order Sticky Summary */}
                        <div className="lg:col-span-4 lg:sticky lg:top-32 h-fit space-y-6">
                            <div className="card-premium p-8 bg-black text-white">
                                <h2 className="text-2xl font-bold mb-8">Summary</h2>
                                
                                <div className="space-y-4 pb-8 border-b border-white/10">
                                    <div className="flex justify-between text-gray-400 text-sm">
                                        <span>Subtotal</span>
                                        <span className="font-bold text-white">₹{calculateSubtotal()}</span>
                                    </div>
                                    <div className="flex justify-between text-gray-400 text-sm">
                                        <span>GST (18%)</span>
                                        <span className="font-bold text-white">₹{Math.round(calculateSubtotal() * 0.18)}</span>
                                    </div>
                                </div>

                                <div className="pt-8 space-y-8">
                                    <div className="flex justify-between items-end">
                                        <span className="text-lg font-bold">Payable amount</span>
                                        <span className="text-4xl font-black text-primary">₹{Math.round(calculateSubtotal() * 1.18)}</span>
                                    </div>
                                    
                                    <div className="space-y-4">
                                        <button 
                                            type="submit"
                                            className="btn-primary w-full !py-5 shadow-xl hover:shadow-2xl shadow-primary/20 text-lg flex items-center justify-center gap-3 transition-transform hover:scale-[1.02]"
                                        >
                                            <HiOutlineShieldCheck size={24} />
                                            Book Securely
                                        </button>
                                        <p className="text-[10px] text-center text-gray-400 font-medium uppercase tracking-widest leading-relaxed">
                                            By proceeding, you agree to our <br />
                                            <span className="text-primary underline cursor-pointer">Terms Choice</span> & <span className="text-primary underline cursor-pointer">Refund Policy</span>
                                        </p>
                                    </div>
                                </div>
                            </div>

                            <div className="p-6 rounded-3xl border border-border space-y-4">
                                <h4 className="font-bold flex items-center gap-2">
                                    <HiOutlineShieldCheck className="text-green-500" />
                                    AstraClean Protection
                                </h4>
                                <ul className="space-y-2">
                                    <li className="text-[11px] text-muted-foreground flex gap-2">
                                        <span className="text-primary">•</span>
                                        Verified background professionals
                                    </li>
                                    <li className="text-[11px] text-muted-foreground flex gap-2">
                                        <span className="text-primary">•</span>
                                        Insurance coverage for damages
                                    </li>
                                    <li className="text-[11px] text-muted-foreground flex gap-2">
                                        <span className="text-primary">•</span>
                                        100% Satisfaction Guarantee
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </form>
                </div>
            </section>

            <Footer />
        </div>
    );
};

export default Checkout;

